import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 9 7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M1.204 3.583a.68.68 0 0 0-.975-.052.72.72 0 0 0-.052.997l1.676 1.904a.77.77 0 0 0 1.098.058L8.66 1.23a.72.72 0 0 0 .05-.997.68.68 0 0 0-.975-.053L2.475 5.027z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }